import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

interface ExpiringMembership {
  userId: string;
  userName: string;
  expiresAt: Date;
  daysLeft: number;
}

interface ExpiringMembershipsProps {
  memberships: ExpiringMembership[];
}

export const ExpiringMemberships = ({ memberships }: ExpiringMembershipsProps) => {
  const getDaysLeftColor = (days: number) => {
    if (days <= 5) return "text-red-500 bg-red-500/10";
    if (days <= 15) return "text-yellow-500 bg-yellow-500/10";
    return "text-green-500 bg-green-500/10";
  };

  return (
    <Card className="border-border/50 bg-card/50 backdrop-blur-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-yellow-500" />
          Membresías por Vencer
        </CardTitle>
      </CardHeader>
      <CardContent>
        {memberships.length === 0 ? (
          <p className="text-muted-foreground text-sm py-4 text-center">
            No hay membresías próximas a vencer
          </p>
        ) : (
          <div className="space-y-3">
            {memberships.map((membership) => (
              <div
                key={membership.userId}
                className="flex items-center justify-between p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="text-sm font-medium text-primary">
                      {membership.userName.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <div>
                    <p className="font-medium text-foreground">{membership.userName}</p>
                    <p className="text-xs text-muted-foreground">
                      Vence: {membership.expiresAt.toLocaleDateString('es-AR')}
                    </p>
                  </div>
                </div>
                <div className={cn(
                  "flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium",
                  getDaysLeftColor(membership.daysLeft)
                )}>
                  <Clock className="h-3 w-3" />
                  {membership.daysLeft} días
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
